import { Pipe, PipeTransform } from '@angular/core';
import { Config } from '@shared/configs/config';

@Pipe({ name: 'assetsFile', pure: true })
export class AssetsFilePipe implements PipeTransform {
  transform(value?: string): string | null {
    return value ? Config.ASSETS + value : null;
  }
}
